import type { IGetApplies } from "@api";
import type { IApply } from "@bbj-types/apply";
import type { ISettingValueMaster } from "@bbj-types/setting";
import { getSettingsLabelFromValue } from "@candidate/components/utils/formatTools";

export const getApplyTitle = (id: string, applys?: IGetApplies) =>
  applys?.data.find((apply) => apply._id === id)?.offer.name ?? "";

export const getApplySubtext = (apply: IApply, setting?: ISettingValueMaster[]) => {
  let text = apply.offer?.enterprise?.name ?? "";
  const contractType = apply.offer.contractType?.[0];
  if (contractType) {
    text += (text ? " . " : "") + getSettingsLabelFromValue(contractType, setting);
  }
  if (apply.offer?.address?.city) {
    text += (text ? " . " : "") + apply.offer.address.city;
  }
  return text;
};
